import React from 'react';

const LogoPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-orange-500">
      <h1 className="text-white text-4xl">Logo Page</h1>
    </div>
  );
};

export default LogoPage;